// extracted by mini-css-extract-plugin
module.exports = {"SnippetCarouselItemBordered":"snippet-carousel-item-bordered_SnippetCarouselItemBordered__bu3sY"};